import React from 'react';
import cn from 'classnames';
import styles from "./Divider.module.scss";
export const Divider = _ref => {
  let {
    skin = 'default',
    orientation = 'horizontal',
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles[skin], styles[orientation], className)
  });
};